
import React from 'react';
import '../../src/skins.css';
import { ReactComponent as Angular } from '../img/angular.svg';
import { ReactComponent as JQuery } from '../img/jquery.svg';
import { ReactComponent as MySql}  from '../img/mysql.svg';
import { ReactComponent as Tailwind} from '../img/tailwindcss.svg';
import { ReactComponent as Node } from '../img/nodejs.svg';
import { ReactComponent as Aws } from '../img/aws.svg';
import { ReactComponent as GitHub } from '../img/github.svg';
import { ReactComponent as Git } from '../img/git.svg';

function Skins() {
    return (
        <div className='cntn justify-content-center'>
            <div className='container justify-content-center'>
                <div className='row mt-5 justify-content-center'>
                    <h2 className='gradient-text'>Skill`s</h2>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className='col-md-2 col-5 container-skin' title='HTML'>
                                <a href='https://certificados.programadorbr.com/certificado/DVWBDO14HT21082'
                                   target='_blanck'>
                                    <div className='m-2 icon'><i style={{color: '#dd4b25'}}
                                                                 className="fa-brands fa-html5"></i></div>
                                </a>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='CSS'>
                                <a href='https://certificados.programadorbr.com/certificado/DVWBDO14HT21082'
                                   target='_blanck'>
                                    <div className='m-2 icon'><i style={{color: '#1664c0'}}
                                                                 className="fa-brands fa-css3-alt"></i></div>
                                </a>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='PHP'>
                                <div className='m-2 icon'><i style={{color: '#7377ad'}}
                                                             className="fa-brands fa-php"></i></div>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='JavaScript'>
                                <a href='https://certificados.programadorbr.com/certificado/DVWBDO14HT21082'
                                   target='_blanck'>
                                    <div className='m-2 icon'><i style={{color: '#e2c60b'}}
                                                                 className="fa-brands fa-js"></i></div>
                                </a>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='Laravel'>
                                <div className='m-2 icon'><i style={{color: 'red'}}
                                                             className="fa-brands fa-laravel"></i></div>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='NodeJs'>
                                <a href='https://certificados.programadorbr.com/certificado/DVWBDJDOF31NO21067'
                                   target='_blanck'>
                                    <Node className='mt-4' width="35" height="35"/>
                                </a>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='ReactJS'>
                                <a href='https://certificados.programadorbr.com/certificado/DVWBDJDOF31RE21067'
                                   target='_blanck'>
                                    <div className='m-2 icon mt-3'><i style={{color: '#087ea4'}}
                                                                      className="fa-brands fa-react"></i></div>
                                </a>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='Angular.JS'>
                                <Angular className='m-4 icon' width="35" height="35"/>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='JQuery'>
                                <JQuery width="80" height="80"/>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='MySQL'>
                                <MySql className='mt-2' width="60" height="60"/>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='Docker'>
                                <a href='https://hermes.dio.me/certificates/CLXAZSDN.pdf' target='_blanck'>
                                    <div className='mt-3 icon'><i style={{color: '#1d63ed'}}
                                                                 className="fa-brands fa-docker"></i></div>
                                </a>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='Bootstrap e Tailwind'>
                                <div className='m-3 icon'>
                                    <i style={{color: '#563d7c'}} className="fa-brands fa-bootstrap"></i>
                                    <Tailwind style={{marginLeft: 10}} width="40" height="40"/>
                                </div>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='GIT e GitHub'>
                                <div className='m-3 icon'>
                                    <Git width="40" height="40" />
                                    <GitHub width="40" height="40"/>
                                </div>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='Jira e Trello'>
                                <div className='m-3 icon'>
                                    <i style={{color: '#0556cc', margin: 10}} className="fa-brands fa-jira"></i>
                                    <i style={{color: '#0556cc'}} className="fa-brands fa-trello"></i>
                                </div>
                            </div>
                            <div className='col-md-2 col-5 container-skin' title='AWS'>
                                <div className='m-2 icon'>
                                    <Aws width="35" height="35"/>
                                    <p style={{ fontSize: 10 }}>EC2, RDS e S3</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skins;
